import { getMacroregions } from '~/components/SearchSuggest/constants';

/**
 * Effective states for copy / SEO / placeholders: when the URL has only a macroregion
 * (no `states` query), expand to `searchParams.states` from the static catalog — same
 * behaviour everywhere in Shorts UI.
 */
export function resolveShortsLocationStatesForLabels(
	macroregions: readonly string[],
	states: readonly string[]
): string[] {
	const macroregionName = macroregions[0];
	if (macroregionName && states.length === 0) {
		const expanded =
			getMacroregions().find(m => m.macroregionUsed === macroregionName)
				?.searchParams.states ?? [];
		return [...expanded];
	}
	return [...states];
}
